module.exports = __webpack_public_path__ + "img/wallet-four.6f448e6c.svg";